(function () {

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire04f6"];
var parcelRegister = parcelRequire.register;
parcelRegister("HNUci", function(module, exports) {

var $cYr9j = parcelRequire("cYr9j");

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $3sHb8 = parcelRequire("3sHb8");

var $dcsZi = parcelRequire("dcsZi");

var $amul4 = parcelRequire("amul4");

var $jjExS = parcelRequire("jjExS");

var $1Mpn7 = parcelRequire("1Mpn7");

var $eP3xl = parcelRequire("eP3xl");
var $083aba7123cddab7$var$CreatALertnew = /*#__PURE__*/ function(_React_Component) {
    "use strict";
    (0, $dcsZi._)(CreatALertnew, _React_Component);
    function CreatALertnew(props) {
        (0, $4GJKx._)(this, CreatALertnew);
        var _this;
        _this = (0, $cYr9j._)(this, CreatALertnew, [
            props
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(_this, "state", {
            areas: [],
            city_id: null
        });
        _this.areas_cities = _this.areas_cities.bind(_this);
        return _this;
    }
    (0, $1wc17._)(CreatALertnew, [
        {
            key: "areas_cities",
            value: function areas_cities(event) {
                var _this = this;
                var _city_id = event.target.value;
                var _url = "".concat(BASE.url, "areas-by-city-id/").concat(_city_id);
                fetch(_url).then(function(res) {
                    return res.json();
                }).then(function(res) {
                    _this.setState({
                        areas: res.data,
                        city_id: _city_id
                    });
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var categories = window.CATEGORIES;
                var cities = window.CITIES_DATA;
                var _areas = this.state.areas;
                var _obj;
                return /*#__PURE__*/ (0, $amul4.jsx)("div", {
                    className: "CreatALertnew",
                    children: /*#__PURE__*/ (0, $amul4.jsxs)("div", {
                        className: "content",
                        children: [
                            /*#__PURE__*/ (0, $amul4.jsxs)("div", {
                                className: "alert-form-inputs",
                                children: [
                                    /*#__PURE__*/ (0, $amul4.jsx)("div", {
                                        className: "input-field",
                                        children: /*#__PURE__*/ (0, $amul4.jsxs)("select", (_obj = {
                                            required: true,
                                            className: "input input-select",
                                            name: "category_id"
                                        }, (0, $3sHb8._)(_obj, "required", true), (0, $3sHb8._)(_obj, "children", [
                                            /*#__PURE__*/ (0, $amul4.jsx)("option", {
                                                selected: true,
                                                disabled: true,
                                                value: "",
                                                children: modalV4.select_categoy
                                            }),
                                            categories && categories.data.map(function(item) {
                                                return /*#__PURE__*/ (0, $amul4.jsx)("option", {
                                                    value: item.id,
                                                    children: item.category_name
                                                }, item.id);
                                            })
                                        ]), _obj))
                                    }),
                                    /*#__PURE__*/ (0, $amul4.jsx)("div", {
                                        className: "input-field",
                                        children: /*#__PURE__*/ (0, $amul4.jsxs)("select", {
                                            value: this.state.city_id,
                                            className: "input input-select",
                                            onChange: this.areas_cities,
                                            name: "city_id",
                                            required: true,
                                            children: [
                                                /*#__PURE__*/ (0, $amul4.jsx)("option", {
                                                    selected: true,
                                                    disabled: true,
                                                    value: "",
                                                    children: modalV4.choose_city
                                                }),
                                                cities && cities.map(function(city) {
                                                    return /*#__PURE__*/ (0, $amul4.jsx)("option", {
                                                        value: city.city_id,
                                                        children: city.city_name
                                                    }, city.city_id);
                                                })
                                            ]
                                        })
                                    }),
                                    _areas && _areas.length ? /*#__PURE__*/ (0, $amul4.jsx)("div", {
                                        className: "input-field",
                                        children: /*#__PURE__*/ (0, $amul4.jsxs)("select", {
                                            className: "input input-select",
                                            name: "area_id",
                                            required: true,
                                            id: "area_id",
                                            children: [
                                                /*#__PURE__*/ (0, $amul4.jsx)("option", {
                                                    selected: true,
                                                    disabled: true,
                                                    value: "",
                                                    children: modalV4.choose_area
                                                }),
                                                _areas && _areas.map(function(area) {
                                                    return /*#__PURE__*/ (0, $amul4.jsx)("option", {
                                                        value: area.id,
                                                        children: area.name
                                                    }, area.id);
                                                })
                                            ]
                                        })
                                    }) : null,
                                    /*#__PURE__*/ (0, $amul4.jsx)("div", {
                                        className: "input-field",
                                        children: /*#__PURE__*/ (0, $amul4.jsx)("input", {
                                            className: "input input-basic",
                                            dir: "",
                                            type: "text",
                                            placeholder: modalV4.price_from,
                                            name: "price_from"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $amul4.jsx)("div", {
                                        className: "input-field ",
                                        children: /*#__PURE__*/ (0, $amul4.jsx)("input", {
                                            className: "input input-basic",
                                            dir: "",
                                            type: "text",
                                            placeholder: modalV4.price_to,
                                            name: "price_to"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $amul4.jsxs)("div", {
                                className: "alert-form-actions",
                                children: [
                                    /*#__PURE__*/ (0, $amul4.jsx)("input", {
                                        type: "submit",
                                        className: "btn primary-1-btn",
                                        value: modalV4.alert_submit
                                    }),
                                    /*#__PURE__*/ (0, $amul4.jsx)("span", {
                                        className: "input-field-hint",
                                        children: modalV4.alert_message
                                    })
                                ]
                            })
                        ]
                    })
                });
            }
        }
    ]);
    return CreatALertnew;
}((0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).Component);
var $083aba7123cddab7$var$CreatALerts = document.getElementById("CreatALert");
if ($083aba7123cddab7$var$CreatALerts) (0, (/*@__PURE__*/$parcel$interopDefault($eP3xl))).render(/*#__PURE__*/ (0, $amul4.jsx)($083aba7123cddab7$var$CreatALertnew, {}), $083aba7123cddab7$var$CreatALerts);

});
parcelRegister("3sHb8", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $28557b013f37bb6b$export$71511d61b312f219; });
function $28557b013f37bb6b$export$71511d61b312f219(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}

});

parcelRegister("jjExS", function(module, exports) {

var $53r23 = parcelRequire("53r23");
function $e0ff3e210908ac38$var$_defineProperty(e, r, t) {
    return (r = $53r23(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
module.exports = $e0ff3e210908ac38$var$_defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("53r23", function(module, exports) {

var $2nffd = parcelRequire("2nffd");
var $3ae2339789af7f0c$var$_typeof = $2nffd.default;

var $a5ZpV = parcelRequire("a5ZpV");
function $3ae2339789af7f0c$var$toPropertyKey(t) {
    var i = $a5ZpV(t, "string");
    return "symbol" == $3ae2339789af7f0c$var$_typeof(i) ? i : i + "";
}
module.exports = $3ae2339789af7f0c$var$toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("2nffd", function(module, exports) {
function $1ba98e0025765fea$var$_typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = $1ba98e0025765fea$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $1ba98e0025765fea$var$_typeof(o);
}
module.exports = $1ba98e0025765fea$var$_typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("a5ZpV", function(module, exports) {

var $2nffd = parcelRequire("2nffd");
var $759a032db56b9f84$var$_typeof = $2nffd.default;
function $759a032db56b9f84$var$toPrimitive(t, r) {
    if ("object" != $759a032db56b9f84$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $759a032db56b9f84$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
module.exports = $759a032db56b9f84$var$toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;

});




})();
//# sourceMappingURL=alert.62e2a98e.js.map
